const FieldValidationCodes = {
	Name: "name",
	Code: "code",
	Description: "description",
	FirstName: "firstName",
	LastName: "lastName",
	EmailAddress: "emailAddress",
	EmailAddressMandatory: "emailAddressMandatory",
	PhoneNumber: "phoneNumber",
	PhoneNumberMandatory: "phoneNumberMandatory",
	RegisteredName: "registeredName",
	BrandName: "brandName",
	Website: "website",
	UrlWithPath: "urlWithPath",
	Biography: "biography",
	BuildingNameNumber: "buildingNameNumber",
	BuildingNameNumberRequired: "buildingNameNumberRequired",
	StreetRoadBlock: "streetRoadBlock",
	StreetRoadBlockRequired: "streetRoadBlockRequired",
	Locality: "locality",
	Latitude: "latitude",
	Longitude: "longitude",
	CityTown: "cityTown",
	StateProvinceRegion: "stateProvinceRegion",
	PostZipCode: "postZipCode",
	PostZipCodeRequired: "postZipCodeRequired",
	CountryCode: "countryCode",
	TaxNumber: "taxNumber",
	RegistrationNumber: "registrationNumber",
	JobTitle: "jobTitle",
	Instructions: "instructions",
	PayrollNumber: "payrollNumber",
	NationalInsuranceNumber: "nationalInsuranceNumber",
	NationalInsuranceNumberRequired: "nationalInsuranceNumberRequired",
	BankAccountName: "bankAccountName",
	BankAccountSortCode: "bankAccountSortCode",
	BankAccountNumber: "bankAccountNumber",
	AvailabilityRestriction: "availabilityRestriction",
	AvailabilityRestrictionDate: "availabilityRestrictionDate",
	ConvictionDetails: "convictionDetails",
	LegacyId: "legacyId",
	AddressTypes: "addressTypes",
	LocationType: "locationType",
	Position: "position",
	BookingOwner: "bookingOwner",
	BookingContact: "bookingContact",
	BookingBranch: "bookingBranch",
	BookingLocation: "bookingLocation",
	BookingDates: "bookingDates",
	BookingDate: "bookingDate",
	BookingRolePosition: "bookingRolePosition",
	BookingRoleSkills: "bookingRoleSkills",
	BookingRoleUniform: "bookingRoleUniform",
	BookingRoleDesk: "bookingRoleDesk",
	BookingWorker: "bookingWorker",
	BookingInstructions: "bookingInstructions",
	BookingPurchaseOrderNumber: "bookingPurchaseOrderNumber",
	PayRate: "payRate",
	ShiftDate: "shiftDate",
	Password: "password",
	PasswordConfirmation: "passwordConfirmation",
	WorkTypes: "workTypes",
	EmergencyContactName: "emergencyContactName",
	EmergencyContactPhoneNumber: "emergencyContactPhoneNumber",
	DateOfBirth: "dateOfBirth",
	Time15MinuteIntervals: "time15MinuteIntervals",
	Time: "time",
	DeclinedReason: "declinedReason",
	CancelledReason: "cancelledReason",
	HealthAndSafetyAssessmentDate: "healthAndSafetyAssessmentDate",
	FormType: "formType",
	FaqTitle: "faqTitle",
	QuestionTitle: "questionTitle",
	QuestionType: "questionType",
	Distance: "distance",
	JourneyTemplate: "journeyTemplate",
	JobBranch: "jobBranch",
	JobDesk: "jobDesk",
	JobOwner: "jobOwner",
	JobSalaryMin: "jobSalaryMin",
	JobSalaryMax: "jobSalaryMax",
	JobLocation: "jobLocation",
	JobContact: "jobContact",
	JobPrimaryPosition: "jobPrimaryPosition",
	JobTitleRequired: "jobTitleRequired",
	JobDesiredStartDate: "jobDesiredStartDate",
	JobClosedReason: "jobClosedReason",
	InterviewType: "interviewType",
	InterviewDate: "interviewDate",
	InterviewStartAt: "interviewStartAt",
	InterviewEndAt: "interviewEndAt",
	InterviewContact: "interviewContact",
	InterviewInPersonAddressType: "interviewInPersonAddressType",
	InterviewOtherLocation: "interviewOtherLocation",
	InterviewOfficeAddress: "interviewOfficeAddress",
	InterviewInstructions: "interviewInstructions",
	InterviewFeedback: "interviewFeedback",
	JobOfferSalary: "jobOfferSalary",
	JobOfferStartDate: "jobOfferStartDate",
	BookingRoleWorkerShiftRejectedReason: "bookingRoleWorkerShiftRejectedReason",
	AppMinimumVersion: "appMinimumVersion",
	ConversationTopicBusinessHours: "conversationTopicBusinessHours",
	ConversationTopicBranch: "conversationTopicBranch",
	ConversationTopicDesk: "conversationTopicDesk",
	ConversationTopicBusinessHoursGroup: "conversationTopicBusinessHoursGroup",
	ConversationTopicOutOfHoursGroup: "conversationTopicOutOfHoursGroup",
	ConversationTopic: "conversationTopic",
	ConversationSubject: "conversationSubject",
	ConversationMessage: "conversationMessage",
	DefaultBranch: "defaultBranch",
	DefaultDesk: "defaultDesk",
	DeskExternalAccountingAccount: "deskExternalAccountingAccount",
	DeskExternalAccountingCategory: "deskExternalAccountingCategory",
	EmailTemplateType: "emailTemplateType",
	EmailTemplateId: "emailTemplateId",
	IntegrationSetting: "integrationSetting",
	IntegrationSystemId: "integrationSystemId",
	OfflineMessage: "offlineMessage",
	Status: "status",
	SpecOutWorker: "specOutWorker",
	SpecOutOwner: "specOutOwner",
	SpecOutBranch: "specOutBranch",
	SpecOutDesk: "specOutDesk",
	SpecOutEmailTemplate: "specOutEmailTemplate",
	OpportunityName: "opportunityName",
	OpportunitySource: "opportunitySource",
	OpportunityOwner: "opportunityOwner",
	OpportunityWorkType: "opportunityWorkType"
}
export default FieldValidationCodes
